module.exports = __webpack_public_path__ + "img/format_2.9228b9d6.svg";